import { InputTextField, InputDateField, InputDropdownField } from "./Form";
import { useForm } from "react-hook-form";

import React from "react";
import {Button, Grid, Typography} from "@mui/material";
import {useParams} from "react-router-dom";
import {useMe} from "../config/api/queries";


const biologicalSexOptions = [
    {
        label: 'Please select an option (required)',
        value: '',
    },
    {
        label: 'Male',
        value: 'M',
    },
    {
        label: 'Female',
        value: 'F',
    },
];

export const TestKitRegistrationForm = (): JSX.Element => {
    const { control } = useForm();
    let { code } = useParams();
    const me = useMe();

    const getKitRegistrationCodeFromURL = () => {
        return code || '';
    }

    // prevent the form from submitting and grab the form data
    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const data = Object.fromEntries(formData.entries());
        console.log("Sending data to API:");
        console.log(data);
    }

    if (me.isLoading) {
        return <></>;
    }

    return (
        <form onSubmit={onSubmit}>
            <Typography variant="medium" fontSize={20}>Register Your Test Kit</Typography>
            <Grid item sx={{ mb: 2}}>
                <InputTextField
                    control={control}
                    defaultValue={me?.data?.first_name || ''}
                    fullWidth
                    name="firstName"
                    required
                />
            </Grid>
            <Grid item sx={{ mb: 2}}>
                <InputTextField
                    control={control}
                    defaultValue={me?.data?.last_name || ''}
                    fullWidth
                    name="lastName"
                    required
                />
            </Grid>
            <Grid item sx={{ mb: 2}}>
                <InputTextField
                    control={control}
                    defaultValue={me?.data?.email || ''}
                    fullWidth
                    name="email"
                    required
                />
            </Grid>
            <Grid item sx={{ mb: 2}}>
                <InputDropdownField
                    control={control}
                    label="Biological Sex *"
                    name="sex"
                    options={biologicalSexOptions}
                    defaultValue={biologicalSexOptions[0].value}
                    fullWidth
                    required
                />
            </Grid>
            <Grid item sx={{ mb: 2}}>
                <InputDateField
                    control={control}
                    label="Date of Birth *"
                    name="date_of_birth"
                    fullWidth
                    required
                />
            </Grid>
            <Grid item sx={{ mb: 2}}>
                <InputTextField
                    control={control}
                    defaultValue={me?.data?.phone || ''}
                    label={me.data?.phone ? '' : "Phone Number"}
                    name="phone_number"
                    fullWidth
                />
            </Grid>
            <Grid item sx={{ mb: 2}}>
                <InputTextField
                    control={control}
                    label="Kit Registration Code"
                    name="kit_registration_code"
                    defaultValue={getKitRegistrationCodeFromURL()}
                    fullWidth
                    required
                />
            </Grid>
            <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ mt: 3, mb: 2 }}
                fullWidth={true}
            >
                <Typography variant="medium" fontSize={20}>
                    Register
                </Typography>
            </Button>
        </form>
    );
}
